import { Link } from 'react-router-dom';
import { PATHS } from '../../../../constants/routes';
import SectionBody from '../../../layouts/showcaseLayouts/Section/SectionBody/SectionBody';
// import Placeholder from '../../../UI/Placeholder/Placeholder';
import './inDevelopment.scss';

const InDevelopment: React.FC = () => {
    return (
        <SectionBody>
            <div className="inDevelopment">
                {/* <Placeholder text={'Страница в разработке'} /> */}
                <h1 className="inDevelopment__title">Страница в разработке</h1>

                <div className="inDevelopment__wrapper">
                    <span className="inDevelopment__navTitle">Перейти:</span>
                    <div className="inDevelopment__navBox">
                        <Link className="inDevelopment__navBox_elem" to={PATHS.main}>
                            На главную
                        </Link>
                        <Link className="inDevelopment__navBox_elem" to={`${PATHS.showcase}`}>
                            В каталог
                        </Link>
                    </div>
                </div>
            </div>
        </SectionBody>
    );
};

export default InDevelopment;
